import apiService from "@/services/apiService";

const actions = {
  getGuideBook({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService
        .post("error-guide/find-with-paging", payload)
        .then(response => {
          commit("setGuideBook", response.data.data);
          resolve(response.data.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getGuideBookDetail({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiService
        .get(`error-guide/${id}`)
        .then(response => {
          commit("setGuideBookDetail", response.data.data);
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
          console.log(error);
        });
    });
  },
  createGuideBook({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService
        .post(`error-guide/store`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editGuideBook({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService
        .put(`error-guide/update/${payload.id}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteGuideBook({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiService
        .delete(`error-guide/remove/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default actions;
